const textFieldFormActions = {
  actionText: 'Ação',
  problemText: 'Problema',
};

export default textFieldFormActions;
